/* ReQaf sticky CTA scroll behavior (mobile + desktop).
 *
 * Watches the natural in-page buy-row (`.reqaf-buybox__buy-row` on PDP by
 * default; overridable per-page via `data-observe-target` on the sticky
 * element — e.g. Build Your Box uses a sentinel element outside its
 * sticky column). When the buy-row is ENTIRELY above the viewport, add
 * `.is-active` to the sticky CTA so it slides up from the bottom. When
 * any part of it is back in view, remove `.is-active` so it slides back
 * down.
 *
 * Uses a scroll listener + getBoundingClientRect instead of Intersection-
 * Observer because Chrome on iOS has intermittent bugs where the initial
 * IO callback fires with stale layout data, causing the sticky to
 * briefly appear on page load before any scrolling. Scroll+rect is
 * deterministic across browsers.
 *
 * Same trigger on mobile and desktop — CSS decides the visual layout
 * of the bar per viewport.
 */

(function () {
  function init() {
    const stickyCta = document.querySelector('[data-reqaf-mobile-cta]');
    if (!stickyCta) return;
    const targetSel = stickyCta.dataset.observeTarget || '.reqaf-buybox__buy-row';
    const buyRow = document.querySelector(targetSel);
    if (!buyRow) return;

    let ticking = false;

    function currentScrollY() {
      // Read scroll from EVERY known source — iOS in-app browsers
      // (Google Search App, Facebook, Instagram) sometimes report 0 on
      // window.scrollY while document.documentElement.scrollTop has the
      // real value, and vice-versa. Take the max of all known sources.
      return Math.max(
        window.scrollY || 0,
        window.pageYOffset || 0,
        document.documentElement ? (document.documentElement.scrollTop || 0) : 0,
        document.body ? (document.body.scrollTop || 0) : 0,
        (document.scrollingElement || {}).scrollTop || 0
      );
    }

    function update() {
      // Hard scroll-position gate: if the user hasn't scrolled at all
      // (within 40px of the top by ANY scroll measurement), the sticky
      // is forced hidden. Belt over the getBoundingClientRect check
      // because iOS in-app browsers can misreport rects on page load
      // and address-bar collapse.
      if (currentScrollY() < 40) {
        stickyCta.classList.remove('is-active');
        ticking = false;
        return;
      }
      const rect = buyRow.getBoundingClientRect();
      // Require the ENTIRE buy-row to be above the viewport (its bottom
      // edge has scrolled past the top). Prevents a premature "on" state
      // when only the top of a tall element crosses the viewport top.
      const scrolledPast = rect.bottom < 0;
      stickyCta.classList.toggle('is-active', scrolledPast);
      ticking = false;
    }

    function onScrollOrResize() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    // Initial evaluation — run in the next frame so layout has settled
    // (fixes Chrome iOS quirk where getBoundingClientRect on DOMContent-
    // Loaded occasionally reports pre-layout coordinates). Also strip
    // the `hidden` attribute we render server-side, so from this point
    // on the CSS transform + .is-active gate controls visibility.
    requestAnimationFrame(function () {
      update();
      stickyCta.removeAttribute('hidden');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
